import React from 'react';
import classnames from 'classnames';
import s from './TextTooltipContent.scss';

const SHORT_CONTENT_THRESHOLD = 30;

export interface Props {
  textClassName?: string;
  title?: string;
  tooltipText?: React.ReactNode;
}

/** @deprecated */
const TextTooltipContent: React.FC<Props> = ({ textClassName, title, tooltipText }) => {
  const isShortContent =
    typeof tooltipText === 'string' && tooltipText.length <= SHORT_CONTENT_THRESHOLD;
  const alignment = (isShortContent && 'center') || undefined;
  return (
    <div className={s['wrapper']}>
      {title && <div className={s['title']}>{title}</div>}
      <div className={classnames(s['text'], alignment && s[`align-${alignment}`], textClassName)}>
        {tooltipText}
      </div>
    </div>
  );
};

export default TextTooltipContent;
